import type { ReactNode } from 'react';
import { useMemo } from 'react';

import type { IconName } from '@similarweb/icons';

import { formatPercentage, formatWithPrecision } from '../../../services/numberFormat';
import { secondsToTimeString } from '../../../services/timeFormat';
import { MetricIcon } from '../MetricIcon';

import { StyledMetric, StyledMetricName, StyledMetricValue } from './styles';

const FORMAT_FUNCTIONS_MAP = {
  percentage: formatPercentage,
  number: formatWithPrecision,
  time: secondsToTimeString,
};

export const Metric = ({
  name,
  value,
  format = 'number',
  extraContent,
  iconName,
}: {
  name: string;
  value?: number | string;
  format?: 'percentage' | 'number' | 'time';
  extraContent?: ReactNode;
  iconName?: IconName;
}) => {
  const formatFn = useMemo(() => FORMAT_FUNCTIONS_MAP[format], [format]);

  const getFormattedValue = () => {
    if (!value) {
      return 'N/A';
    }
    if (typeof value === 'string') {
      return value;
    }
    return formatFn(value, 2);
  };

  return (
    <StyledMetric withIcon={!!iconName}>
      {iconName ? <MetricIcon iconName={iconName} /> : null}
      <StyledMetricName data-automation={`TrafficMetric-${name}`}>{name}</StyledMetricName>
      {extraContent ? extraContent : null}
      <StyledMetricValue>{getFormattedValue()}</StyledMetricValue>
    </StyledMetric>
  );
};
